import * as FaIcons from "react-icons/fa";

import {
  ActivityIndicator,
  StyleSheet,
  TouchableOpacity,
  View,
} from "react-native-web";
import React, { useEffect, useState } from "react";
import { TableBody, TableCell, TableRow } from "@material-ui/core";
import { getAllUsers, searchUsers } from "services/user-service";

import { COLORS } from "constants/Colors";
import FormInput from "components/Inputs/FormInput";
import { Links } from "constants/Links";
import { PrimaryText } from "components/Common/PrimaryText";
import Table from "components/Common/TableComponent/Table/Table";
import { getAge } from "utils/helpers";
import loginLeft from "assets/images/loginLeft.jpg";
import moment from "moment";
import { useMessages } from "context/MessagesContext";
import { useNavigate } from "react-router-dom";
import { useUsers } from "context/UserContext";
import { useDisplay } from "context/DisplayContext";

const pageSize = 10;

export const StartChatListing = () => {
  const navigate = useNavigate();
  const { userData, loading, setLoading } = useUsers();
  const { createChat, checkIfChatExists } = useMessages();
  const { isMobile, isSmallHeight, viewportHeight } = useDisplay();

  const isCompact = isMobile || isSmallHeight;

  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (search) {
      searchUsers(search, setRows);
    } else {
      setRows(userData);
    }
  }, [search, userData]);

  async function startChatWithUser(user) {
    try {
      const existingChat = checkIfChatExists(user.id);

      if (existingChat) {
        navigate(Links.Messaging);
        return;
      }

      await createChat(user.id);
      navigate(Links.Messaging);
    } catch (error) {
      console.error("Error starting chat:", error);
    }
  }

  const currentTableData = () => {
    const firstPageIndex = (page - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    return rows.slice(firstPageIndex, lastPageIndex);
  };

  const totalCount = rows?.length;
  const totalPageCount = Math.ceil(totalCount / pageSize);
  const startCount = (page - 1) * pageSize + 1;
  const endCount = startCount + currentTableData()?.length - 1;

  if (loading) {
    return (
      <View
        style={{
          height: viewportHeight - 100,
          width: "100%",
          flexDirection: "column",
          backgroundColor: COLORS.primary.white,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ActivityIndicator
          animating={loading}
          size={"large"}
          style={StyleSheet.absoluteFill}
          color={COLORS.primary.blue}
        />
      </View>
    );
  }

  return (
    <View style={styles.tableContainer}>
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          paddingHorizontal: 24,
          marginTop: 12,
        }}
      >
        <FaIcons.FaSearch size={16} color={COLORS.primary.darkGray} />
        <div className="flex-1" style={{ marginRight: 12 }}>
          <FormInput
            type="search"
            placeholder="Search user by name"
            value={search}
            setValue={setSearch}
          />
        </div>
      </View>

      {currentTableData() && currentTableData().length > 0 && (
        <View style={{ paddingHorizontal: 24, marginTop: 12 }}>
          {isCompact ? (
            currentTableData().map((item) => (
              <View key={item.id} style={styles.mobileCard}>
                <View style={styles.mobileCardHeader}>
                  <img
                    src={item.defaultPic ? item.defaultPic : loginLeft}
                    style={{ width: 44, height: 44, borderRadius: 22, objectFit: "cover", marginRight: 12 }}
                  />
                  <View style={styles.mobileCardInfo}>
                    <PrimaryText fontSize={14} fontWeight={600}>
                      {item.firstName} {item.lastName}
                    </PrimaryText>
                    <PrimaryText fontSize={12} fontWeight={300} style={{ color: COLORS.primary.darkGray }}>
                      {item.currentCity || "N/A"} · {getAge(item)?.value} years
                    </PrimaryText>
                  </View>
                </View>
                <TouchableOpacity
                  onPress={() => startChatWithUser(item)}
                  style={styles.startChatButton}
                >
                  <FaIcons.FaComment
                    size={16}
                    color={COLORS.primary.white}
                  />
                  <PrimaryText
                    fontSize={14}
                    fontWeight={400}
                    style={{ color: COLORS.primary.white, marginLeft: 8 }}
                  >
                    Start Chat
                  </PrimaryText>
                </TouchableOpacity>
              </View>
            ))
          ) : (
            <Table>
              <TableBody>
                {currentTableData().map((item, index) => {
                  return (
                    <TableRow
                      hover
                      key={item.id}
                    >
                      <TableCell style={{ height: 50, padding: 0 }}>
                        <img
                          src={item.defaultPic ? item.defaultPic : loginLeft}
                          style={{
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <PrimaryText fontSize={14} fontWeight={400}>
                          {item.firstName} {item.lastName}
                        </PrimaryText>
                      </TableCell>
                      <TableCell>
                        <PrimaryText fontSize={14} fontWeight={400}>
                          {getAge(item)?.value} years
                        </PrimaryText>
                      </TableCell>
                      <TableCell>
                        <PrimaryText fontSize={14} fontWeight={400}>
                          {item.currentCity || "N/A"}
                        </PrimaryText>
                      </TableCell>
                      <TableCell>
                        <PrimaryText fontSize={14} fontWeight={400}>
                          {item.createdAt
                            ? moment(item.createdAt.toDate()).format(
                                "MMM DD YYYY"
                              )
                            : ""}
                        </PrimaryText>
                      </TableCell>
                      <TableCell>
                        <TouchableOpacity
                          onPress={() => startChatWithUser(item)}
                          style={styles.startChatButton}
                        >
                          <FaIcons.FaComment
                            size={16}
                            color={COLORS.primary.white}
                          />
                          <PrimaryText
                            fontSize={14}
                            fontWeight={400}
                            style={{ color: COLORS.primary.white, marginLeft: 8 }}
                          >
                            Start Chat
                          </PrimaryText>
                        </TouchableOpacity>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          )}
        </View>
      )}

      {currentTableData() && currentTableData().length === 0 && (
        <View
          style={{
            height: viewportHeight - 200,
            width: "100%",
            flexDirection: "column",
            backgroundColor: COLORS.primary.white,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <PrimaryText fontSize={16} fontWeight={400}>
            No users found
          </PrimaryText>
        </View>
      )}

      <View
        style={{
          flexDirection: "row",
          alignSelf: "flex-end",
          marginTop: 12,
          paddingHorizontal: 24,
        }}
      >
        <TouchableOpacity
          onPress={() => (page > 1 ? setPage(page - 1) : null)}
          disabled={page <= 1}
        >
          <FaIcons.FaChevronLeft
            size={20}
            color={
              page <= 1 ? COLORS.primary.lightGray : COLORS.primary.darkGray
            }
          />
        </TouchableOpacity>

        <View style={{ width: 125, alignItems: "center" }}>
          <PrimaryText fontSize={14} fontWeight={400}>
            {`${startCount} - ${endCount} of ${totalCount}`}
          </PrimaryText>
        </View>

        <TouchableOpacity
          onPress={() => (page < totalPageCount ? setPage(page + 1) : null)}
          disabled={page >= totalPageCount}
        >
          <FaIcons.FaChevronRight
            size={20}
            color={
              page >= totalPageCount
                ? COLORS.primary.lightGray
                : COLORS.primary.darkGray
            }
          />
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  tableContainer: {
    width: "100%",
  },
  startChatButton: {
    flexDirection: "row",
    backgroundColor: COLORS.primary.darkBlue,
    justifyContent: "center",
    alignItems: "center",
    padding: 8,
    paddingHorizontal: 16,
    borderRadius: 6,
    minHeight: 44,
  },
  mobileCard: {
    backgroundColor: COLORS.primary.white,
    borderRadius: 8,
    padding: 12,
    marginBottom: 12,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
  },
  mobileCardHeader: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 12,
  },
  mobileAvatar: {
    width: 44,
    height: 44,
    borderRadius: 22,
    objectFit: "cover",
    marginRight: 12,
  },
  mobileCardInfo: {
    flex: 1,
    flexDirection: "column",
  },
});
